import { useInView } from '../hooks/useInView';
import { experiences } from '../data/portfolioData';

export default function Experience() {
  const [ref, inView] = useInView(0.1);

  return (
    <section id="experience" ref={ref}>
      <div className="max-w-5xl mx-auto px-6 lg:px-16 py-24">
        <div className={`reveal ${inView ? 'visible' : ''}`}>
          <div className="section-eyebrow">03 — Where I've worked</div>
        </div>
        <h2 className={`reveal ${inView ? 'visible' : ''} delay-1`}
          style={{ fontSize: 'clamp(2rem,5vw,3.2rem)', fontWeight: 700, letterSpacing: '-0.02em', marginBottom: '0.75rem' }}>
          Experience
        </h2>
        <p className={`reveal ${inView ? 'visible' : ''} delay-2`}
          style={{ color: 'var(--text2)', fontSize: '1.05rem', maxWidth: 520, lineHeight: 1.7, marginBottom: '3.5rem' }}>
          Professional journey from intern to software engineer.
        </p>

        {/* Timeline */}
        <div style={{ position: 'relative' }}>
          {/* Vertical line */}
          <div style={{
            position: 'absolute', left: 23, top: 0, bottom: 0, width: 1,
            background: 'linear-gradient(to bottom, var(--accent), transparent)',
          }} />

          {experiences.map((exp, i) => (
            <div
              key={exp.role + exp.company}
              className={`reveal-left ${inView ? 'visible' : ''} delay-${i + 3}`}
              style={{ paddingLeft: '3.5rem', paddingBottom: '2.5rem', position: 'relative' }}
            >
              {/* Dot */}
              <div style={{
                position: 'absolute', left: 16, top: 6,
                width: 15, height: 15, borderRadius: '50%',
                background: 'var(--bg)', border: '2px solid var(--accent)',
                transition: 'background 0.3s, box-shadow 0.3s',
                zIndex: 1,
              }} />

              {/* Card */}
              <div
                style={{
                  padding: '1.4rem 1.75rem', borderRadius: 16,
                  border: '1px solid var(--border)', background: 'var(--card)',
                  transition: 'border-color 0.3s, transform 0.3s',
                  cursor: 'default',
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(124,109,250,0.35)'; e.currentTarget.style.transform = 'translateX(4px)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.transform = ''; }}
              >
                {/* Header row */}
                <div className="flex flex-wrap gap-2 justify-between items-start mb-1">
                  <div>
                    <div style={{ fontSize: '1rem', fontWeight: 600 }}>{exp.role}</div>
                    <div style={{ fontSize: '0.88rem', color: 'var(--accent)', marginTop: 2 }}>{exp.company}</div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{
                      fontFamily: "'Space Mono', monospace", fontSize: '0.72rem',
                      color: 'var(--text2)', padding: '0.22rem 0.7rem',
                      border: '1px solid var(--border)', borderRadius: '100px',
                    }}>
                      {exp.duration}
                    </div>
                    <div style={{ fontSize: '0.7rem', color: 'var(--text2)', marginTop: 3, paddingRight: 4 }}>
                      {exp.type}
                    </div>
                  </div>
                </div>

                {/* Bullets */}
                <ul style={{ margin: '0.8rem 0', padding: 0, listStyle: 'none' }}>
                  {exp.bullets.map((b, j) => (
                    <li key={j} style={{
                      paddingLeft: '1.1rem', position: 'relative',
                      color: 'var(--text2)', fontSize: '0.87rem', lineHeight: 1.65, marginBottom: '0.3rem',
                    }}>
                      <span style={{ position: 'absolute', left: 0, color: 'var(--accent)', fontSize: '0.75em', top: '0.1em' }}>→</span>
                      {b}
                    </li>
                  ))}
                </ul>

                {/* Tech tags */}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem', marginTop: '0.9rem' }}>
                  {exp.tech.map(t => (
                    <span key={t} style={{
                      fontSize: '0.72rem', padding: '0.22rem 0.6rem', borderRadius: '100px',
                      background: 'rgba(124,109,250,0.1)', border: '1px solid rgba(124,109,250,0.2)',
                      color: 'var(--accent)', fontFamily: "'Space Mono', monospace",
                    }}>
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
